module.exports = __webpack_public_path__ + "img/tenants.b3cb8a5d.svg";